var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CustomerStatsService } from './customer-stats.service';
import { ToastrService } from 'ngx-toastr';
var IMAGES = {
    noOfOrders: {
        'background-image': "url('/assets/svgImages/no_of_orders.svg')"
    },
    starRating: {
        'background-image': "url('/assets/svgImages/star.svg')",
    },
    lastAppLogin: {
        'backgroundImage': "url('/assets/svgImages/last_login.svg')"
    },
    lastOrderDate: {
        'background-image': "url('/assets/svgImages/last_order_date.svg')",
    },
    avgRating: {
        'background-image': "url('/assets/svgImages/avg_rating.svg')"
    }
};
var CustomerStatsComponent = /** @class */ (function () {
    function CustomerStatsComponent(customerStatsService, toastr) {
        this.customerStatsService = customerStatsService;
        this.toastr = toastr;
        this.todayDate = this.formatDate(new Date());
        this.dateRange = 'Today, ' + this.todayDate;
        this.dataLoaded = false;
    }
    CustomerStatsComponent.prototype.ngOnChanges = function (changes) {
        this.dataLoaded = false;
        if (changes.data && changes.data.currentValue) {
            if (changes.data.currentValue === 'empty') {
                this.emptyCard();
            }
            else {
                this.data = changes.data.currentValue;
                this.constructCard();
            }
        }
        else {
            this.emptyCard();
        }
    };
    CustomerStatsComponent.prototype.ngOnInit = function () {
    };
    CustomerStatsComponent.prototype.emptyCard = function () {
        this.info = {
            stats: [],
            dataFetched: false
        };
        this.dataLoaded = true;
    };
    CustomerStatsComponent.prototype.constructCard = function () {
        return __awaiter(this, void 0, void 0, function () {
            var averageCustomerRatingFromSvoc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.data) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.customerStatsService.getAverageRatingFromSvoc(this.data.id)];
                    case 1:
                        averageCustomerRatingFromSvoc = _a.sent();
                        this.dataLoaded = true;
                        this.info = {
                            dataFetched: true,
                            stats: [
                                { header: 'Average ratings', value: averageCustomerRatingFromSvoc ? averageCustomerRatingFromSvoc : 'N/A',
                                    style: IMAGES.avgRating },
                                { header: 'Last order date', value: this.data.lastOrderDate, style: IMAGES.lastOrderDate },
                                { header: 'Last app login', value: this.data.lastAppLogin, style: IMAGES.lastAppLogin }
                            ],
                            dateRange: this.dateRange
                        };
                        return [3 /*break*/, 3];
                    case 2:
                        this.dataLoaded = true;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerStatsComponent.prototype.refresh = function () {
        this.dataLoaded = false;
        this.constructCard();
    };
    CustomerStatsComponent.prototype.formatDate = function (date) {
        var monthNames = [
            'January', 'February', 'March',
            'April', 'May', 'June', 'July',
            'August', 'September', 'October',
            'November', 'December'
        ];
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        return day + ' ' + monthNames[monthIndex] + ' ' + year;
    };
    return CustomerStatsComponent;
}());
export { CustomerStatsComponent };
